// Utility functions for managing IELTS user data across components

export const saveIELTSUserData = (data) => {
  localStorage.setItem(
    "ieltsUserProfile",
    JSON.stringify({
      ...data,
      lastUpdated: new Date().toISOString(),
    })
  );
};

export const getIELTSUserData = () => {
  try {
    const data = localStorage.getItem("ieltsUserProfile");
    return data ? JSON.parse(data) : null;
  } catch (error) {
    console.error("Error getting IELTS user data:", error);
    return null;
  }
};

export const clearIELTSUserData = () => {
  localStorage.removeItem("ieltsUserProfile");
  localStorage.removeItem("userData");
  localStorage.removeItem("ieltsOnboardingData");
};

export const saveIELTSTestResults = (results) => {
  localStorage.setItem("ieltsTestResults", JSON.stringify(results));
};

export const getIELTSTestResults = () => {
  try {
    const data = localStorage.getItem("ieltsTestResults");
    return data ? JSON.parse(data) : null;
  } catch (error) {
    console.error("Error getting IELTS test results:", error);
    return null;
  }
};
